
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[countryCode]/product/[paramName]",
      function () {
        return require("private-next-pages/[countryCode]/product/[paramName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[countryCode]/product/[paramName]"])
      });
    }
  